import { useNavigate } from "react-router-dom";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import { useEffect, useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";

import {
  NuDate,
  NuInput,
  NuInputWithError,
  NuMobileNumber,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import axiosInstance from "../../../../Services/axiosCommon";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import FormikSelectTwo, {
  FormikSelectWithAdd,
  SelectProductWithError,
} from "../../../../Components/Utils/Select";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData, {
  DropDownAddUnitWithError,
} from "../../../../Components/Utils/selectAddMetaData";
import UseInspectorDD from "../../../../Components/Hooks/useInspectorSearch";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";
import {  EditIcon } from "lucide-react";
import { Select } from "antd";
import UseDropDownNew from "../../../../Components/Hooks/useDropDownNew";
import UsecatEquipDD from "../../../../Components/Hooks/UseCatEquipDD";
import DeleteIcon from "../../../../Components/Icons/Delete";


function CreateSurveyReport() {
  const { value: industry, getData: refindustry } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "industry"
  );

  const navigate = useNavigate();
  const { addFormData, isLoading } = useAddFormData();
  const [searchClient, setSearchClient] = useState("");
  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );
  // const [searchInspector, setSearch] = useState("");
  // const { data: inspector, setDataInspector } = UseInspectorDD(
  //   "/inspectors/drop-down",
  //   searchClient
  // );
  const [searchequipment, setSearchequipment] = useState("");
  const [searcheCat, setSearcheCat] = useState("");

  const [isEquipmentEditable, setIsEquipmentEditable] = useState(false);
   const [addEquipment, setAddEquipment] = useState({
    equipmentId: "",
    unit: "",
    quantity: "",
    categoryId:""
  });

  const formikAddEquipment = useFormik({
    initialValues: addEquipment,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const { data: user } = UseDropDown(`/user/new-drop-down`);
  const { value: unit, getData: refunit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "unit_equipments"
  );

    const { data: form } = UseDropDownNew(`/form/drop-down`);

  const [createNew, setCreateNew] = useState({
    attachments: [],
    clientId: "",
    project: "",
    scope: "",
    inspector: "",
    location: "",
    inspectionDate: "",
    status: "",
    assignee: "",
    equipments:[],
  });
   const [Equipitems, setEquipItems] = useState([]);
  const { value: Rating, getData: refRating } = useFetchMetaStar(
    `/dropdown/dropdown-details/`,
    "ratings"
  );
  const [oldData, setOldData] = useState([]);
const [selectedCategoryId, setSelectedCategoryId] = useState(null);

// track categoryId from formik
useEffect(() => {
  setSelectedCategoryId(formikAddEquipment.values.categoryId);
}, [formikAddEquipment.values.categoryId]);
useEffect(() => {
  setSelectedCategoryId(formikAddEquipment.values.categoryId);
}, [formikAddEquipment.values.categoryId]);

 const { data: Item, setData } = UsecatEquipDD(
  "/equipments/drop-down",
  searchequipment,
  selectedCategoryId
);


  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);
  const toast = useToast();

      function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      clientId: yup.string().required("Client is required!"),
      // inspector: yup
      //   .string()
      //   .required("Inspector is required!"),
      // assignee: yup.string().required("Assignee is required!"),
      // assignee: yup.array().required("Assigned To is required!"),
      
      
    }),
    onSubmit: async (value, { resetForm }) => {

      if (Equipitems.length === 0) {
    setEquipmentError("Equipment is required!");
    return;
  }
          const valueWithItems = {
        ...value,
        equipments: Equipitems,
        
        
      };
  

      let formData = new FormData();
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      await addFormData({
        url: `/survey-report/new-survey-report`,
        formData: formData,
        navigateUrl: `/Contract-management/survey-report`,
        resetForm: resetForm,
      });

      // addFormData("/survey-report/new-survey-report", formData, resetForm);
    },
  });

 const [showPopupCat, setShowPopupCat] = useState(false);

  const togglePopupCat = () => {
    setShowPopupCat(!showPopupCat);
  };

  const resetFormCat = () => {
    formik.values.name = "";
   

    setShowPopupCat(false);
  };

  const handlePopupSubmitCat = async (e) => {
    e.preventDefault();

    
    try {
      const response = await axiosInstance.post(
        "/categories/new-category",
        { name: formik.values.name }
      );
      getContractsByClientId()
      const createdcat = response.data?.data;

      setData((prevCat) => [
        {
          label: formik.values.name || "-",
          value: createdcat,
        },
        ...prevCat,
      ]);
      resetFormCat();
    } catch (error) {
      console.error("Error creating new customer:", error);
    }
  };



  const [showPopupEquipment, setShowPopupEquipment] = useState(false);

  const togglePopupEqupiment = () => {
    setShowPopupEquipment(!showPopupEquipment);
  };

  const resetFormE = () => {
    formik.values.name = "";
   

    setShowPopupEquipment(false);
  };

  const handlePopupSubmitEquipmt = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append(
      "json_data",
      JSON.stringify({
        name: formik.values.name || "",
        categoryId: formikAddEquipment.values.categoryId || "",

       
      })
    );
    try {
      const response = await axiosInstance.post(
        "/equipments/new-equipment",
        formData
      );
      
      const createdEquipt = response.data?.data;

      setData((prevEquipments) => [
        {
          label: formik.values.name || "-",
          value: createdEquipt,
        },
        ...prevEquipments,
      ]);
      resetFormE();
    } catch (error) {
      console.error("Error creating new customer:", error);
    }
  };

  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const resetForm = () => {
    //  formik.values.type = ""
    formik.values.companyName = "";
    formik.values.email = "";
    formik.values.industry = "";
    formik.values.pcName = "";
    formik.values.pcDesignation = "";
    formik.values.pcCountryCode = "";
    formik.values.pcMobile = "";
    formik.values.phoneCC = "";
    formik.values.phone = "";
    formik.values.ratings = "";

    setShowPopup(false);
  };
  const { value: designation, getData: refdesignation } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "desigination"
  );
  const handlePopupSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append(
      "json_data",
      JSON.stringify({
        companyName: formik.values.companyName || "",
        email: formik.values.email || "",
        industry: formik.values.industry || "",
        category: formik.values.category || "",
        pcName: formik.values.pcName || "",
        pcDesignation: formik.values.pcDesignation || "",
        pcCountryCode: formik.values.pcCountryCode || "",
        pcMobile: formik.values.pcMobile || "",
        phone: formik.values.phone || "",
        phoneCC: formik.values.phoneCC || "",
        ratings: formik.values.ratings || "",
      })
    );
    try {
      const response = await axiosInstance.post(
        "/clients/new-client",
        formData
      );
      const createdAgent = response.data?.data;

      setDataCustomer((prevCustomers) => [
        {
          label: formik.values.companyName || "-",
          value: createdAgent,
        },
        ...prevCustomers,
      ]);
      resetForm();
    } catch (error) {
      console.error("Error creating new customer:", error);
    }
  };

  const [value, setValue] = useState({
    equipEnabled: false,
    id: 1,
  });

  const handleToggleChange = (id) => {
    setValue((prevValue) => ({
      ...prevValue,
      equipEnabled: !prevValue.equipEnabled,
    }));
  };



  const [equipmentProductError, setEquipmentProductError] = useState("");
  const [equipmentCatError, setEquipmentCatError] = useState("");

  const [equipmentUnitError, setEquipmentUnitError] = useState("");
  const [equipmentQuantityError, setEquipmentQuantityError] = useState("");
  const [equipmentError, setEquipmentError] = useState("");

  const handleAddEquipment = () => {
    let hasError = false;
     if (!formikAddEquipment.values.categoryId) {
      setEquipmentCatError("Category is required");
      hasError = true;
    } else {
      setEquipmentCatError("");
    }
    if (!formikAddEquipment.values.equipmentId) {
      setEquipmentProductError("Equipment is required");
      hasError = true;
    } else {
      setEquipmentProductError("");
    }
    if (!formikAddEquipment.values.unit) {
      setEquipmentUnitError("Unit is required");
      hasError = true;
    } else {
      setEquipmentUnitError("");
    }
    if (!formikAddEquipment.values.quantity) {
      setEquipmentQuantityError("Quantity is required");
      hasError = true;
    } else {
      setEquipmentQuantityError("");
    }
    if (hasError) return;

    if (
      formikAddEquipment.values.equipmentId &&
      formikAddEquipment.values.quantity
    ) {
      const newItem = {
        categoryId: formikAddEquipment.values.categoryId,
categoryname:filteredCategories.find(
            (i) => i.value === formikAddEquipment.values.categoryId
          )?.label || formikAddEquipment.values.categoryId,
        equipmentId: formikAddEquipment.values.equipmentId,
        productName:
          Item.find(
            (i) => i.value === formikAddEquipment.values.equipmentId
          )?.label || formikAddEquipment.values.equipmentId,
        quantity: formikAddEquipment.values.quantity,
        unit: formikAddEquipment.values.unit,
      };
      setEquipItems([...Equipitems, newItem]);
      let updatedItems = Item.filter(
        (it) => it.value !== formikAddEquipment.values.equipmentId
      );
      setData(updatedItems);
      formikAddEquipment.resetForm();
      setAddEquipment({
        categoryId:"",
        equipmentId: "",
        unit: "",
        quantity: "",
      });
      setEquipmentError("");
    }
  };

  const handleQuantityChange = (e, index, section) => {
    const updatedQuantity = e.target.value;
    const updatedItems = Equipitems.map((item, idx) => {
      if (idx === index) {
        return { ...item, quantity: updatedQuantity };
      }
      return item;
    });
    setEquipItems(updatedItems);
  };

const handleProductUnitChange = (value, index, section) => {
  const updatedItems = Equipitems.map((item, idx) => {
    if (idx === index) {
      return { ...item, unit: value };
    }
    return item;
  });
  setEquipItems(updatedItems);
};


  const handleDeleteItem = (indexToDelete, section) => {
    const deletedItem = Equipitems[indexToDelete];
    const updatedItems = Equipitems.filter(
      (_, index) => index !== indexToDelete
    );
    setEquipItems(updatedItems);
    if (deletedItem) {
      setData([
        ...Item,
        { value: deletedItem.equipmentId, label: deletedItem.productName },
      ]);
    }
  };



   const [Newcat, setcat] = useState([]);

  function getContractsByClientId(clientId) {
    axiosInstance
      .get(`/categories/`)
      .then((res) => {
       if (Array.isArray(res.data.data)) {
        const formatted = res.data.data.map(item => ({
          value: item.id,        
          label: item.name      
        }));
        setcat(formatted);
        } else {
          console.error("Unexpected API response format");
          setcat([]);
        }
      })
      .catch(err => {
        console.error("Error fetching contracts by client ID:", err);
        setcat([]);
      });
  }

  useEffect(() => {
     getContractsByClientId();

  }, [])
const filteredCategories = Newcat.filter(item =>
  item.label.toLowerCase().includes(searcheCat.toLowerCase())
);


  return (
    <div className=" w-full h-full py-2 px-4 ">
      <div className="flex justify-between w-full">
        <Breadcrumb
          items={[
            {
              name: "Survey",
              link: "/Contract-management/survey-report",
            },

            { name: "Create" },
          ]}
        />
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <SettingHeading title="Survey" />
            </div>
            <FormikSelectWithAdd
              type="text"
              label="Client "
              placeholder="Client  "
              Options={client}
              formik={formik}
              name="clientId"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
              handleClick={togglePopup}
              FixPosition={true}
                      PortalTarget={false}
              setSearch={setSearchClient}
            />
            <NuInput
              type="text"
              label="Project"
              placeholder="Project"
              formik={formik}
              name="project"
              width="w-full md:w-1/3 md:-mt-2"
            />
          
            <MultiSelect
              label="Assignee"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="assignee"
              // isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
              FixPosition={true}
                      PortalTarget={false}
            />
            <NuInput
              type="text"
              label="Location"
              placeholder="Location"
              formik={formik}
              name="location"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="Inspection Date"
              placeholder="Inspection Date"
              formik={formik}
              name="inspectionDate"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <MultiSelect
              label="Form"
              Options={form}
              formik={formik}
              placeholder="Choose"
              name="formSelection"
              width="w-full md:w-1/3 md:-mt-2"
              FixPosition={true}
                      PortalTarget={false}
            />

            <NuTextArea
              type="text"
              label="Scope of Work"
              placeholder="Scope of Work"
              formik={formik}
              name="scope"
              width="w-full md:w-1/2 md:-mt-2"
            />

           

            <div className="w-full">
              <SettingHeading title="Attchment " />
            </div>
            <Attachement
              handleChange={handleImageChange}
              preview={image || ""}
              width="w-full"
              label="Attach"
              multiple={true}
              removeImages={removeImages}
            />

             <div className=" flex items-center gap-3">
              <p className=" text-xs 2xl:text-sm ">Enable Equipment List</p>
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={value?.equipEnabled}
                  onChange={() => handleToggleChange(value.id)}
                  className="sr-only peer"
                />
                <div
                  className={`relative w-11 h-6 rounded-full peer 
                        ${
                          value?.equipEnabled
                            ? "bg-baseColor-primary"
                            : "bg-gray-300"
                        }`}
                >
                  <div
                    className={`absolute top-0.5 left-0.5 bg-white border-gray-300 border rounded-full h-5 w-5 transition-all 
                          ${value?.equipEnabled ? "transform translate-x-5" : ""}`}
                  ></div>
                </div>
                {/* <span className="ml-2 text-sm font-medium text-gray-900">
                        {value?.enabled ? 'Enabled' : 'Disabled'}
                      </span> */}
              </label>
            </div>

            {value?.equipEnabled == true && (
              <div className="w-full h-auto flex justify-start content-start flex-wrap mb-4">
                <div className="w-full flex justify-between p-2">
                  <div className="w-full px-2">
                    <SettingHeading title="Equipment Detail" />
                  </div>
                  {/* <div className="flex gap-4">
                  <ImportButton
                    label="Import"
                    handleClick={handleImportClick}
                  />
                  <ExportButton
                    label="Export"
                    handleClick={() => setShowExport(true)}
                  />
                </div> */}
                </div>
                <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                  
                 
                   <SelectProductWithError
                    type="text"
                    label="Category "
                    placeholder="Category "
                    Options={filteredCategories}
                    formik={formikAddEquipment}
                    name="categoryId"
                    width="w-full md:w-1/2 lg:w-2/5 z-10"
                    ErrMessage={equipmentCatError}
                    px="0"
                    handleClick={togglePopupCat}
                    setSearch={setSearcheCat}
                    FixPosition={true}
                    PortalTarget={false}
                  />
                  <SelectProductWithError
                    type="text"
                    label="Equipment "
                    placeholder="Equipment "
                    Options={Item}
                    formik={formikAddEquipment}
                    name="equipmentId"
                    width="w-full md:w-1/2 lg:w-2/5 z-9"
                    ErrMessage={equipmentProductError}
                    px="0"
                    handleClick={togglePopupEqupiment}
                    setSearch={setSearchequipment}
                    FixPosition={true}
                    PortalTarget={false}
                  />
                  <DropDownAddUnitWithError
                    label="Unit"
                    placeholder="Choose"
                    Options={unit}
                    formik={formikAddEquipment}
                    name="unit"
                    width="w-full md:w-1/2 lg:w-1/5"
                    getFunc={refunit}
                    displayProperty={"Add Unit"}
                    propertyName={"unit_equipments"}
                    ErrMessage={equipmentUnitError}
                    FixPosition={true}
                    PortalTarget={false}
                  />
                  <NuInputWithError
                    label="Quantity"
                    type="number"
                    formik={formikAddEquipment}
                    placeholder="Quantity"
                    name="quantity"
                    width="w-full md:w-1/2 lg:w-1/5"
                    ErrMessage={equipmentQuantityError}
                  />
                  <button
                    onClick={handleAddEquipment}
                    type="button"
                    className="p-1 mt-8 m-1 text-center h-8 cursor-pointer bg-baseColor-primary border border-solid border-white text-xs font-medium text-white rounded-lg"
                  >
                    Add
                  </button>
                </div>
                <div className="w-full bg-white overflow-y-scroll mt-5">
                  {equipmentError && (
                    <p className="text-xs font-semibold text-red-500 px-4">
                      {equipmentError}
                    </p>
                  )}
                  <div className="w-full py-3 bg-baseColor-primary justify-between rounded-lg px-6 hidden md:flex">
                    <p className="w-[5%] text-left text-white text-xs font-medium">
                      S.No
                    </p>
                   
                    <p className="w-[15%] text-left  text-white text-xs font-medium">
                      Category
                    </p>
                     <p className="w-[40%] text-left text-white text-xs font-medium">
                      Equipment
                    </p>
                    <p className="w-[15%] text-center text-white text-xs font-medium flex justify-center">
                      Unit
                    </p>
                    <p className="w-[20%] text-center text-white text-xs font-medium flex justify-center">
                      Quantity
                    </p>
                    <p className="w-[5%] text-right text-white text-xs font-medium ">
                      Action
                    </p>
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => setIsEquipmentEditable((prev) => !prev)}
                    >
                      <EditIcon
                        width="14"
                        height="14"
                        color={isEquipmentEditable ? "#facc15" : "#ffff"}
                      />
                    </span>
                  </div>
                  <div className="h-[calc(100vh-300px)] overflow-y-scroll hidden md:block">
                    {Equipitems.map((List, index) => (
                      <div
                        key={index}
                        className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                      >
                        <p className="w-[5%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {index + 1}
                        </p>
                      
                        <p className="w-[15%] text-left  text-xs font-medium text-[#111537] py-2.5">
                         {List?.categoryname}
                        </p>
                          <p className="w-[40%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {List?.productName}
                        </p>
                        <p className="w-[15%] text-center  text-xs font-medium text-[#111537]">
                         <Select
  value={unit.find((item) => String(item.value) === String(List?.unit)) || null}
  options={isEquipmentEditable ? unit : []}
                            className="w-11/12 text-center"

  onChange={(value) => handleProductUnitChange(value, index, "equipment")}
  disabled={!isEquipmentEditable}
  placeholder="Select Unit"
  
/>

                        </p>
                        <p className="w-[20%] text-center text-xs font-medium text-[#111537] ">
                          <input
                            type="number"
                            className="w-11/12 py-2.5 mx-auto outline-none text-center border border-gray-300 rounded"
                            value={List?.quantity}
                            disabled={!isEquipmentEditable}
                            onChange={(e) =>
                              handleQuantityChange(e, index, "equipment")
                            }
                          />
                        </p>
                        <div className="w-[5%] text-right py-2.5">
                          <button
                            onClick={() => handleDeleteItem(index, "equipment")}
                            type="button"
                            className="text-red-500 cursor-pointer ml-4 border-none"
                          >
                            <DeleteIcon color="red" height={12} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* mobile */}
                  <div className="md:hidden space-y-4 ">
                    {Equipitems.map((List, index) => (
                      <div
                        key={index}
                        className="p-3 border text-xs font-medium text-[#111537] rounded shadow-sm space-y-2 bg-gray-50"
                      >
                        <div className="text-right">
                          <button
                            onClick={() => handleDeleteItem(index, "equipment")}
                            type="button"
                            className="text-red-500 text-xs"
                          >
                            <DeleteIcon color="red" height={12} />
                          </button>
                        </div>
                        <div>
                          <span className="text-xs font-medium text-[#111537]">
                            S.No:
                          </span>{" "}
                          {index + 1}
                        </div>
                         <div>
                          <span className="text-xs font-medium text-[#111537]">
                            Category:
                          </span>{" "}
                          {List?.categoryname}
                        </div>
                        <div>
                          <span className="text-xs font-medium text-[#111537]">
                            Equipment:
                          </span>{" "}
                          {List?.productName}
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-xs font-medium text-[#111537]">
                            Unit:
                          </span>
                          <span
                            className="cursor-pointer text-xs font-medium text-[#111537]"
                            onClick={() =>
                              setIsEquipmentEditable((prev) => !prev)
                            }
                          >
                            <EditIcon
                              width="14"
                              height="14"
                              color={
                                isEquipmentEditable ? "#facc15" : "#9ca3af"
                              }
                            />
                          </span>
                        </div>
                        <Select
                          value={
                            unit.find((item) => item?.value === List?.unit) ||
                            null
                          }
                          options={isEquipmentEditable ? unit : []}
                          onChange={(value) =>
                            handleProductUnitChange(value, index, "equipment")
                          }
                          disabled={!isEquipmentEditable}
                        />
                        <div className="flex justify-between items-center pt-2">
                          <span className="text-xs font-medium text-[#111537]">
                            Quantity:
                          </span>
                          <span
                            className="cursor-pointer text-xs font-medium text-[#111537]"
                            onClick={() =>
                              setIsEquipmentEditable((prev) => !prev)
                            }
                          >
                            <EditIcon
                              width="14"
                              height="14"
                              color={
                                isEquipmentEditable ? "#facc15" : "#9ca3af"
                              }
                            />
                          </span>
                        </div>
                        <input
                          type="number"
                          className="w-full border px-2 py-1 rounded text-xs"
                          value={List?.quantity}
                          disabled={!isEquipmentEditable}
                          onChange={(e) =>
                            handleQuantityChange(e, index, "equipment")
                          }
                        />
                        
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            <div className="w-full mt-10 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>

      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[80%] md:w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">Add Client</h2>
            <form onSubmit={handlePopupSubmit}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  type="text"
                  label="Company "
                  placeholder="Company "
                  formik={formik}
                  name="companyName"
                  width="w-full md:w-1/2 lg:w-1/2"
                  isRequired={true}
                />

                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="email"
                  width="w-full md:w-1/2 lg:w-1/2"
                  // isRequired={true}
                />
                <NuMobileNumber
                  nunCode="countryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="phone"
                  // isRequired={true}
                  FixPosition={true}
                  PortalTarget={false}
                  width="w-full md:w-1/2 lg:w-1/2"
                />
                <DropDownAddMetaData
                  type="text"
                  label="Industry"
                  placeholder="Industry"
                  Options={industry}
                  formik={formik}
                  name="industry"
                  width="w-full md:w-1/2 lg:w-1/2"
                  displayProperty={"Industry"}
                  propertyName={"industry"}
                  getFunc={refindustry}
                  FixPosition={true}
                  PortalTarget={false}
                />

                <FormikSelectTwo
                  Options={Rating}
                  label=" Ratings"
                  placeholder=" Ratings"
                  formik={formik}
                  name="ratings"
                  width="w-full md:w-1/2 lg:w-1/3"
                />
                <div className="w-full">
                  <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                    Primary Contact :
                  </p>
                </div>
                <NuInput
                  type="text"
                  label="Contact Person "
                  placeholder="Contact Person "
                  formik={formik}
                  name="pcName"
                  // isRequired={true}
                  width="w-full md:w-1/2 lg:w-1/2"
                />

                <DropDownAddMetaData
                  type="text"
                  label="Designation"
                  placeholder="Designation"
                  Options={designation}
                  formik={formik}
                  name="pcDesignation"
                  width="w-full md:w-1/2 lg:w-1/2 md:-mt-1"
                  // isRequired={true}
                  displayProperty={"Designation"}
                  propertyName={"Designation_Client"}
                  getFunc={refdesignation}
                  FixPosition={true}
                  PortalTarget={false}
                />

                <NuMobileNumber
                  nunCode="pcCountryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="pcMobile"
                  // isRequired={true}
                  FixPosition={true}
                  PortalTarget={false}
                  width="w-full md:w-1/2 lg:w-1/2"
                />

                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="pcEmail"
                  // isRequired={true}
                  width="w-full md:w-1/2 lg:w-1/2"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopup}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                  rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showPopupEquipment && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">Add Equipment</h2>
            <form onSubmit={handlePopupSubmitEquipmt}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  label="Name"
                  placeholder="Name"
                  formik={formik}
                  name="name"
                  width="w-full"
                  new_width="w-full"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopupEqupiment}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                              rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
        {showPopupCat && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">Add Category</h2>
            <form onSubmit={handlePopupSubmitCat}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  label="Name"
                  placeholder="Name"
                  formik={formik}
                  name="name"
                  width="w-full"
                  new_width="w-full"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopupCat}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                              rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreateSurveyReport;
